import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"
import { useForm } from "../../../hooks/useForm"
import {
    createSmsDestinatary,
    getSmsDestinataries,
} from "../../../services/destinatary"
import { addSnackbarNotification } from "../../../services/snackbarNotification"
interface Props {
    open: boolean
    onClose?: (event?: {}, reason?: "backdropClick" | "escapeKeyDown") => void
}

const SmsDestinataryFormModal: React.FC<Props> = ({ open, onClose }) => {
    const [values, , handleChange] = useForm<Partial<SmsDestinatary>>({
        number: "",
        name: "",
    })
    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose()
            }}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent>
                <div className="flex mt-2  justify-around">
                    <div>
                        <TextField
                            id="name"
                            fullWidth
                            color="primary"
                            label="Nombre"
                            size="medium"
                            value={values.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <TextField
                            id="number"
                            fullWidth
                            color="primary"
                            label="Numero"
                            size="medium"
                            value={values.number}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    onClick={async () => {
                        try {
                            await createSmsDestinatary(values)
                            addSnackbarNotification({
                                message: "Destinatario añadido",
                            })
                            getSmsDestinataries()
                            onClose()
                        } catch (error) {
                            addSnackbarNotification({
                                message:
                                    error?.message ?? "Ha ocurrido un error",
                                type: "error",
                            })
                        }
                    }}
                    variant="contained"
                >
                    Agregar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default SmsDestinataryFormModal
